import React from 'react';
import {Link, Redirect, useHistory, useLocation} from 'react-router-dom';
import {useSelector, useDispatch} from 'react-redux';
import Input from '@iso/components/uielements/input';
import IntlMessages from '@iso/components/utility/intlMessages';
import authAction from '@iso/redux/auth/actions';
import appAction from '@iso/redux/app/actions';
import melian_logo from '@iso/assets/images_main/logo_melian.svg';
import {logos} from '@iso/config/config';
import {textos} from '@iso/config/config';
import {logosLogin} from '@iso/config/config';
import SignInStyleWrapper from './SignIn.styles';
import {Row, Col} from 'antd';
import {multicurso, userCanRegister} from "../../../config/config";
import { api } from '@iso/config/site.config';
import Loader from '@iso/components/utility/loader';


const {login} = authAction;
const {clearMenu} = appAction;

export default function SignIn() {
  let history = useHistory();
  const dispatch = useDispatch();
  const isLoggedIn = useSelector(state => state.Auth.idToken);
  const { search } = useLocation();
  const [loading, setLoading] = React.useState(false);

  const [redirectToReferrer, setRedirectToReferrer] = React.useState(false);
  const [state, setState] = React.useState({
    name: '',
    lastname: '',
  });
  const [code, setCode] = React.useState('');

  React.useEffect(() => {
    if (isLoggedIn) {
      setRedirectToReferrer(true);
    }
    loadUserName();
  }, [isLoggedIn]);

  const loadUserName = () => {
    setLoading(true)

    if (getCode('code')) {
      let apiParams = {
        code: getCode('code'),
        type: getCode('type'),
      };
      setCode(getCode('code'))
      api.get('/auth/getUserName', {params: apiParams})
        .then(res => res.data)
        .then(res => {
          if (res.success) {
            setState({
              ...state,
              name: res.name,
              lastname: res.lastname,
            });
          }
          setLoading(false);
        })
        .catch(error => {
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  }
  const getCode = (param) => {
    const params = new URLSearchParams(window.location.search)
    if (params.get('type')) {
      return params.get(param);
    } else if (param === 'code') {
      let codeAr = search.split('code=');
      return codeAr[1];
    } else {
      return null;
    }
  }
  function handleLogin(e) {
    e.preventDefault();
    if (getCode('code')) {
      const userInfo = {
        code: getCode('code'),
        ci: document.getElementById('inpuPassword').value || '',
        type: getCode('type'),
      };
      dispatch(login(userInfo));
    } else {
      const userInfo = {
        email: document.getElementById('inputUserName').value || '',
        password: document.getElementById('inpuPassword').value || '',
      };
      dispatch(login(userInfo));
    }
    // dispatch(clearMenu());
    // history.push('/dashboard');
  }

  //let { from } = location.state || { from: { pathname: '/dashboard' } };
  let from = multicurso ? '/DashboardCursos':'/mis-cursos'

  if (redirectToReferrer) {
    return <Redirect to={from}/>;
  }
  if (loading) {
    return <Loader />;
  }
  // Auspiciadores column Size
  let columnNumber = 12;
  if(logosLogin.length){
     columnNumber = 24 / logosLogin.length;
  }


  return (
    <SignInStyleWrapper className="isoSignInPage">
      <div className="isoLoginContentWrapper">
        <div className="isoLoginContent">
          <div className="isoLogoWrapper">
            <div>
              <div style={{marginBottom: 5, display: 'flex', justifyContent: 'center'}}>
                <img
                  src={process.env.PUBLIC_URL + '/images/images_config/' + logos.logoLogin}
                  className="img-login"
                  alt=""/>
              </div>
              {(textos.textoLogoLogin.length > 0 && textos.textoLogoLogin !== " ") ? (
                <h3 className="texto-login">{textos.textoLogoLogin}</h3>
              ) : (
                <></>
              )}
              {code?
                <>
                  <div style={{marginBottom: 5, textAlign: 'center'}}>
                    <h2>
                      BIENVENIDA
                    </h2>
                  </div>
                  <h3 className="texto-login" style={{marginBottom: 20}}>
                    {state.name + ' ' + state.lastname}
                  </h3>
                  <div className='texto-info-login'>
                    <p>
                      Accede a la Plataforma con el número de tu cédula de identidad.
                    </p>
                    <p>
                      *Evita usar espacios o letras, solo usa números
                    </p>
                  </div>
                </>
                : ''}
            </div>
          </div>
          <div className="isoSignInForm">
            <form>
              {
                (!loading && !code) ?
                  <div className="isoInputWrapper">
                    <Input
                      size="large"
                      placeholder="Correo Electrónico"
                      autoComplete="true"
                      id="inputUserName"
                    />
                  </div>
                : ''
              }

              <div className="isoInputWrapper">
                <Input
                  size="large"
                  type="password"
                  placeholder="Contraseña"
                  autoComplete="false"
                  id="inpuPassword"
                />
              </div>

              <div className="isoInputWrapper isoLeftRightComponent">
                <input type="submit" onClick={handleLogin} value="Iniciar Sesión" className="button-login"/>
              </div>
            </form>
            {userCanRegister ?
            <div className="isoCenterComponent isoHelperWrapper">
              <Link to="/register" className="isoForgotPass">
                Regístrate
              </Link>
            </div>:
            <></>}
            <div className="isoCenterComponent isoHelperWrapper">
              <Link to="/forgotpassword" className="isoForgotPass">
                <IntlMessages id="page.signInForgotPass"/>
              </Link>
            </div>

            <Row gutter={[10, 20]} justify="space-around" align="middle" className='row-logoslogin'>
              {logosLogin.map((auxpiciador, index) => {
                return (
                  <Col key={index} className="gutter-row" xl={columnNumber} lg={columnNumber} md={columnNumber}
                       xs={columnNumber} style={{textAlign: 'center'}}>
                    <img
                      src={process.env.PUBLIC_URL + '/images/images_config/' + auxpiciador.logo}
                      width={auxpiciador.width}
                      height={auxpiciador.height}
                      alt=""
                    />
                  </Col>
                )
              })}
            </Row>

            <div className="logoMelian">
              <p style={{fontFamily: 'Poppins', fontWeight: '300', marginBottom: 13}}>
                Powered by
              </p>
              <img src={melian_logo} width="155px" height="44px" alt=""/>
            </div>

          </div>
        </div>
      </div>
    </SignInStyleWrapper>
  );
}
